// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"eecd02a4","80":"9ec30766","571":"40a507fc","646":"d0e9d078"}[chunkId] + ".chunk.js";
};